module.exports = __webpack_public_path__ + "img/atobarai_abp_450x126.dc9095c2.jpg";